import { cn } from '@/utils/cn';

interface DetailPageSkeletonProps {
  pageClassName?: string;
}

const SkeletonBlock = ({ className }: { className: string }) => (
  <div className={cn('animate-pulse bg-slate-200/80', className)} />
);

export const DetailPageSkeleton = ({ pageClassName = 'bg-app' }: DetailPageSkeletonProps) => (
  <section className={cn('min-h-full', pageClassName)} aria-busy="true" aria-live="polite">
    <span className="sr-only">Loading page details</span>
    <div className="page-shell space-y-8">
      <SkeletonBlock className="h-72 rounded-[2rem] sm:h-80 lg:h-[26rem]" />

      <div className="grid grid-cols-1 gap-8 xl:grid-cols-[1.35fr_0.65fr]">
        <div className="space-y-6">
          <div className="rounded-[1.75rem] border border-slate-200 bg-white/80 p-6">
            <SkeletonBlock className="h-3 w-28 rounded-full" />
            <SkeletonBlock className="mt-6 h-4 w-full rounded-full" />
            <SkeletonBlock className="mt-3 h-4 w-5/6 rounded-full" />
            <div className="mt-7 grid grid-cols-2 gap-5">
              {[1, 2, 3, 4].map((item) => (
                <div key={item}>
                  <SkeletonBlock className="h-3 w-20 rounded-full" />
                  <SkeletonBlock className="mt-3 h-5 w-3/4 rounded-full" />
                </div>
              ))}
            </div>
          </div>

          <div className="rounded-[1.75rem] border border-slate-200 bg-white/80 p-6">
            <SkeletonBlock className="h-3 w-24 rounded-full" />
            <SkeletonBlock className="mt-5 h-16 w-full rounded-xl" />
            <SkeletonBlock className="mt-3 h-16 w-full rounded-xl" />
          </div>
        </div>

        <div className="rounded-[1.75rem] border border-slate-200 bg-white/80 p-6">
          <SkeletonBlock className="h-3 w-24 rounded-full" />
          <SkeletonBlock className="mt-5 h-8 w-2/3 rounded-lg" />
          <SkeletonBlock className="mt-6 h-11 w-full rounded-lg" />
        </div>
      </div>
    </div>
  </section>
);
